import { render, staticRenderFns } from "./LocalityCustomField.vue?vue&type=template&id=781b2270&"
import script from "./LocalityCustomField.vue?vue&type=script&lang=js&"
export * from "./LocalityCustomField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports